import type { FilterState } from '../store';

export interface ListingSortOption {
  value: FilterState['sortBy'];
  label: string;
}

/** Sort dropdown options, in display order. */
export const LISTING_SORT_OPTIONS: ListingSortOption[] = [
  { value: 'hotNew', label: 'Горячие новинки' },
  { value: 'bestMonth', label: 'Лучшее за месяц' },
  { value: 'newest', label: 'По дате создания' },
  { value: 'popular', label: 'По популярности' },
  { value: 'best', label: 'По количеству лайков' },
  { value: 'updated', label: 'По дате обновления' },
];

/** Label shown when the current sort value is not found in the options list. */
export const LISTING_SORT_FALLBACK_LABEL = 'По дате обновления';
